import { SELECT_PRODUCTS } from '../actions/products';

export const selectProductsReducers = (state = '', action) => {
  switch (action.type) {
    case SELECT_PRODUCTS:
      return action.payload;
  }
  return state;
};
